define('viewModels/HelpMenu',[
    'lib/knockout',
    'services/navHelper',
    'services/routeService',
    'viewModels/ViewModel'
], function (
    ko,
    navHelper,
    routeService,
    ViewModel
) {
    'use strict';

    return ViewModel.extend(function () {

        var self = this;

        self.isOpen = ko.observable(false);

        self.contextualHelpURL = routeService.helpURL;

        self.feedbackClick = function(){
            navHelper.navigateTo('feedback');
            self.isOpen(false);
        };

    });

});

